/* Josenart 2.0 — 全站基础 JS（归属 A）。section 私有脚本放各自文件。 */
(function () {
  // 进场：首屏内元素静止可见，其余滚入视口时抬起
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.remove('is-pending');
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.jn-reveal').forEach(function (el) {
    if (el.getBoundingClientRect().top > window.innerHeight) {
      el.classList.add('is-pending');
      io.observe(el);
    }
  });

  // 全站事件约定（B 的 header / cart-drawer 监听这些）：
  //   cart:open           打开购物车抽屉
  //   cart:add  {detail:{id, quantity, properties}}  加购（cart.js 实现，成功后自己触发 cart:updated 并打开抽屉）
  //   cart:updated {detail:{cart}}  购物车变化后广播，header 角标据此刷新
  window.JN = window.JN || {};
  window.JN.emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  };
})();
